import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Tooltip } from '@material-ui/core';
import ShareIcon from '@material-ui/icons/Share';
import { defineMessages, FormattedMessage } from 'react-intl';

import * as actions from '../../../../state';
import { ShareDialog } from '../../../dialogs';
import { selectLayout } from '../../../../state';

const messages = defineMessages({
  SHARE_BOARD: {
    id: 'SHARE_BOARD',
    defaultMessage: 'Share board',
  },
});

function ShareBoardBtn() {
  const dispatch = useDispatch();

  const layout = useSelector(selectLayout);

  return (
    <>
      <Tooltip disableFocusListener title={<FormattedMessage {...messages.SHARE_BOARD} />}>
        <IconButton onClick={() => dispatch(actions.showShareDialog(!layout.showShareDialog))}>
          <ShareIcon />
        </IconButton>
      </Tooltip>

      <ShareDialog />
    </>
  );
}

export default ShareBoardBtn;
